module.exports = __webpack_public_path__ + "shared/static_img/telegram.d7ecc2d7.png";